import { render, staticRenderFns } from "./CreateOpeningAndClosingJournal.vue?vue&type=template&id=10d22084"
import script from "./CreateOpeningAndClosingJournal.vue?vue&type=script&lang=js"
export * from "./CreateOpeningAndClosingJournal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CreateOpeningAndClosingJournal.vue?vue&type=style&index=1&id=10d22084&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports